"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = { class: "inline-flex items-center mr-2" };
const _hoisted_5 = { class: "inline font-bold uppercase text-sm mr-2" };
const _hoisted_6 = { class: "inline font-bold uppercase text-sm" };
const _hoisted_7 = {
    key: 0,
    class: "grow flex justify-end"
};
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-upload" }, null, -1);
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_10 = ["data-text"];
const _hoisted_11 = {
    key: 0,
    class: "flex items-center"
};
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "marso-icon-check" }, null, -1);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "marso-icon-close" }, null, -1);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_21 = ["onClick"];
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_23 = { class: "flex" };
const _hoisted_24 = { class: "flex" };
const _hoisted_25 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_26 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const _hoisted_27 = {
    class: "font-bold underline",
    target: "_blank",
    href: "/coupons/coupons_sample.csv"
};
const _hoisted_28 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_29 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const CouponRequest_1 = require("../../stores/coupon/CouponRequest");
const vue_router_1 = require("vue-router");
const couponStore_1 = require("../../stores/coupon/couponStore");
const Form_2 = require("../../components/Form");
const shop_1 = require("../../common/utils/shop");
const AsyncSearchInputOption_1 = __importDefault(require("../../components/Form/AsyncSearchInput/AsyncSearchInputOption"));
const Form_3 = require("../../components/Form");
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const QuickDateInput_vue_1 = __importDefault(require("../../components/Form/QuickDateInput.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const securityStore_1 = require("../../stores/security/securityStore");
const customersStore_1 = require("../../stores/customers/customersStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminCoupons',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const router = (0, vue_router_1.useRouter)();
        const couponStore = (0, couponStore_1.useCouponStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const uploadedCsv = (0, vue_3.ref)(null);
        const errorMessage = (0, vue_3.ref)("");
        const couponFormModalIsOpen = (0, vue_3.ref)(false);
        const uploadCouponsModalIsOpen = (0, vue_3.ref)(false);
        const selectedCoupon = (0, vue_3.ref)(null);
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "coupons")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "stateKey",
                label: (_b = (0, i18n_1.trans)("stateKey", "State", "coupons")) !== null && _b !== void 0 ? _b : "State",
                value: "stateKey",
                filterable: false,
                sortable: false,
            },
            {
                key: "customer.id",
                label: (_c = (0, i18n_1.trans)("customer_id", "Customer ID", "coupons")) !== null && _c !== void 0 ? _c : "Customer ID",
                value: "customer.id",
                filterable: true,
                sortable: true,
            },
            {
                key: "customer.customerName",
                label: (_d = (0, i18n_1.trans)("customer_name", "Customer", "coupons")) !== null && _d !== void 0 ? _d : "Customer",
                value: "customer.customerName",
                filterable: true,
                sortable: true,
            },
            {
                key: "name",
                label: (_e = (0, i18n_1.trans)("name", "Name", "coupons")) !== null && _e !== void 0 ? _e : "Name",
                value: "name",
                filterable: true,
                sortable: true,
            },
            {
                key: "originalValue",
                label: (_f = (0, i18n_1.trans)("original_value", "Original Value", "coupons")) !== null && _f !== void 0 ? _f : "Original Value",
                value: "originalValue",
                filterable: true,
                sortable: true,
            },
            {
                key: "remainValue",
                label: (_g = (0, i18n_1.trans)("remain_value", "Remain Value", "coupons")) !== null && _g !== void 0 ? _g : "Remain Value",
                value: "remainValue",
                filterable: true,
                sortable: true,
            },
            {
                key: "beginDate",
                label: (_h = (0, i18n_1.trans)("begin_date", "Begin Date", "coupons")) !== null && _h !== void 0 ? _h : "Begin Date",
                value: "beginDate",
                filterable: false,
                sortable: true,
            },
            {
                key: "endDate",
                label: (_j = (0, i18n_1.trans)("end_date", "End Date", "coupons")) !== null && _j !== void 0 ? _j : "End Date",
                value: "endDate",
                filterable: false,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(true);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(10);
        const couponRequest = (0, vue_3.ref)(new CouponRequest_1.CouponRequest());
        const activeCheckbox = (0, vue_3.ref)(true);
        const selectedRemainValueCouponId = (0, vue_3.ref)(null);
        const selectedRemainValue = (0, vue_3.ref)(null);
        const customerAsyncSearchInput = (0, vue_3.ref)(null);
        const selectRemainValue = (couponId, couponRemainValue) => {
            var _a;
            // (DEV-2161) Ha nincs kupon módosítási jogosultság, akkor ne is tudjuk megnyitni a módosítási mezőt
            if (!((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CouponPermissionEnum.COUPON_EDIT)))
                return;
            selectedRemainValueCouponId.value = couponId;
            selectedRemainValue.value = couponRemainValue;
        };
        const unselectRemainValue = () => {
            selectedRemainValueCouponId.value = null;
            selectedRemainValue.value = null;
        };
        const updateRemainValue = () => {
            if (selectedRemainValue.value === null ||
                selectedRemainValueCouponId.value === null) {
                return;
            }
            couponStore
                .updateCouponRemainValue(router, selectedRemainValue.value, selectedRemainValueCouponId.value)
                .then(() => {
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
                selectedRemainValue.value = null;
                selectedRemainValueCouponId.value = null;
                toastStore.addToast({
                    message: (0, i18n_1.trans)("coupon_remain_value_updated_successfully", "Coupon remain value updated successfully!", "coupons"),
                    type: "success",
                    timer: 5,
                });
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        const toggleActiveCheckbox = () => {
            activeCheckbox.value = !activeCheckbox.value;
            page.value = 1;
        };
        const openUploadCouponsModal = () => {
            errorMessage.value = "";
            uploadCouponsModalIsOpen.value = true;
        };
        const openCreateCouponModal = () => {
            errorMessage.value = "";
            couponRequest.value = new CouponRequest_1.CouponRequest();
            selectedCoupon.value = null;
            couponFormModalIsOpen.value = true;
        };
        const openUpdateCouponModal = (coupon) => {
            errorMessage.value = "";
            selectedCoupon.value = coupon;
            couponRequest.value = new CouponRequest_1.CouponRequest(coupon.customer["@id"], coupon.name, coupon.description, coupon.originalValue, coupon.remainValue, coupon.beginDate, coupon.endDate);
            (0, vue_3.nextTick)(() => {
                var _a;
                (_a = customerAsyncSearchInput.value) === null || _a === void 0 ? void 0 : _a.setDisplayValue(`${coupon.customer.customerName} - ${coupon.customer.id}`);
            });
            couponFormModalIsOpen.value = true;
        };
        const deleteCoupon = (coupon) => {
            if (!confirm((0, i18n_1.trans)("delete_coupon_confirm", "Are you sure?", "coupons"))) {
                return;
            }
            errorMessage.value = "";
            couponStore
                .deleteCoupon(router, coupon.id)
                .then(() => {
                page.value = 1;
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        };
        const createCoupon = () => {
            errorMessage.value = "";
            if (couponRequest.value.customer === "") {
                errorMessage.value = (0, i18n_1.trans)("customer_required", "Customer required", "coupons");
                return;
            }
            couponRequest.value.remainValue = couponRequest.value.originalValue;
            couponStore
                .createCoupon(router, couponRequest.value)
                .then(() => {
                couponFormModalIsOpen.value = false;
                page.value = 1;
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        };
        const updateCoupon = () => {
            errorMessage.value = "";
            if (selectedCoupon.value === null) {
                errorMessage.value = (0, i18n_1.trans)("coupon_not_selected", "Coupon not selected", "coupons");
                return;
            }
            if (couponRequest.value.customer === "") {
                errorMessage.value = (0, i18n_1.trans)("customer_required", "Customer required", "coupons");
                return;
            }
            couponStore
                .updateCoupon(router, couponRequest.value, selectedCoupon.value.id)
                .then(() => {
                couponFormModalIsOpen.value = false;
                page.value = 1;
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
            })
                .catch((error) => {
                errorMessage.value = error.toString();
            });
        };
        const requestObject = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            let requestObject = {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
            if (activeCheckbox.value) {
                requestObject["endDate[after]"] = (0, shop_1.formatDate)(new Date());
            }
            else {
                requestObject["endDate[before]"] = (0, shop_1.formatDate)(new Date());
            }
            return requestObject;
        });
        (0, vue_3.watch)([requestObject, currentUser], () => {
            var _a;
            if ((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CouponPermissionEnum.COUPON_EDIT)) {
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
            else {
                couponStore
                    .getCouponsBySite(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
            }
        }, { immediate: true });
        const customerOptions = (0, vue_3.computed)(() => customersStore.customers.map((customer) => new AsyncSearchInputOption_1.default(`${customer.customerName} - ${customer.id}`, customer["@id"])));
        const customerSearchedValueChanged = async (customerSearchedValue) => {
            customersStore.reset();
            let payload = {
                page: 1,
                itemsPerPage: 5,
            };
            if (!isNaN(Number(customerSearchedValue))) {
                payload.id = customerSearchedValue;
                payload["order[id]"] = "asc";
            }
            else {
                payload["customerName"] = customerSearchedValue;
                payload["order[customerName]"] = "asc";
            }
            try {
                await customersStore.getCustomers(router, payload);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const customerSelected = (value) => {
            customersStore.reset();
            couponRequest.value.customer = value.value;
        };
        const uploadCsv = () => {
            errorMessage.value = "";
            const formData = new FormData();
            if (uploadedCsv.value !== null) {
                formData.append("csv", uploadedCsv.value);
            }
            couponStore
                .uploadCouponCsv(router, formData)
                .then(() => {
                uploadedCsv.value = null;
                uploadCouponsModalIsOpen.value = false;
                page.value = 1;
                couponStore
                    .getCoupons(router, requestObject.value)
                    .catch((error) => {
                    errorMessage.value = error.toString();
                });
            })
                .catch((error) => {
                errorMessage.value = error.responseData.message;
            });
        };
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("archived_checkbox_label", "Archived", "coupons")), 1),
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_2.Toggle), {
                                class: "mr-2",
                                checked: activeCheckbox.value,
                                onChange: _cache[0] || (_cache[0] = ($event) => (toggleActiveCheckbox()))
                            }, null, 8, ["checked"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("active_checkbox_label", "Active", "coupons")), 1)
                        ])
                    ]),
                    ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CouponPermissionEnum).COUPON_EDIT))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-success mr-2",
                                onClick: _cache[1] || (_cache[1] = ($event) => (openUploadCouponsModal()))
                            }, [
                                _hoisted_8,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload_coupons", "Upload Coupons", "coupons")), 1)
                            ]),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary",
                                onClick: _cache[2] || (_cache[2] = ($event) => (openCreateCouponModal()))
                            }, [
                                _hoisted_9,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_coupon", "Add Coupon", "coupons")), 1)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[4] || (_cache[4] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(couponStore).coupons,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: (0, vue_2.unref)(couponStore).loading,
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[5] || (_cache[5] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[6] || (_cache[6] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[8] || (_cache[8] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: (0, vue_2.unref)(couponStore).totalCoupons
                }, {
                    "cell-stateKey": (0, vue_2.withCtx)(({ item: coupon }) => [
                        (0, vue_2.createElementVNode)("div", {
                            class: "textbox textbox-right text-left lg:text-center coupon-state",
                            "data-text": (0, vue_2.unref)(i18n_1.trans)('coupon_state_' + coupon.stateKey, coupon.stateValue, 'coupons')
                        }, [
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)([coupon.stateKey, 'w-[10px]', 'h-[10px]', 'inline-block'])
                            }, null, 2)
                        ], 8, _hoisted_10)
                    ]),
                    "cell-originalValue": (0, vue_2.withCtx)(({ item: coupon }) => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.originalValue, "currency", "hu-HU")), 1)
                    ]),
                    "cell-remainValue": (0, vue_2.withCtx)(({ item: coupon }) => {
                        var _a;
                        return [
                            (selectedRemainValueCouponId.value === coupon.id)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "number",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedRemainValue).value = $event)),
                                        class: "w-20 block py-2 px-2 max-w-full placeholder-gray-dark text-[15px] outline-none transition-all duration-300 disabled:bg-gray h-12 border border-gray-dark border-opacity-50 focus:border-blue focus:ring-4 focus:ring-blue focus:ring-opacity-50",
                                        placeholder: String(coupon.remainValue)
                                    }, null, 8, _hoisted_12), [
                                        [vue_2.vModelText, selectedRemainValue.value]
                                    ]),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "h-12 p-2 border border-gray-dark border-opacity-50 bg-white",
                                        onClick: updateRemainValue
                                    }, _hoisted_14),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "h-12 p-2 border border-gray-dark border-opacity-50 bg-white rounded-r-lg",
                                        onClick: unselectRemainValue
                                    }, _hoisted_16)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true),
                            (selectedRemainValueCouponId.value !== coupon.id)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 1,
                                    class: (0, vue_2.normalizeClass)(((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CouponPermissionEnum).COUPON_EDIT)) ? 'underline cursor-pointer' : ''),
                                    onClick: ($event) => (selectRemainValue(coupon.id, coupon.remainValue))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.n)(coupon.remainValue, "currency", "hu-HU")), 11, _hoisted_17))
                                : (0, vue_2.createCommentVNode)("", true)
                        ];
                    }),
                    "cell-actions": (0, vue_2.withCtx)(({ item: coupon }) => {
                        var _a, _b;
                        return [
                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CouponPermissionEnum).COUPON_EDIT))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 0,
                                        class: "btn btn-rounded btn-primary btn-link",
                                        onClick: ($event) => (openUpdateCouponModal(coupon))
                                    }, [
                                        _hoisted_20,
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "coupons")), 1)
                                    ], 8, _hoisted_19))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.CouponPermissionEnum).COUPON_EDIT))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 1,
                                        class: "btn btn-rounded btn-danger btn-link",
                                        onClick: ($event) => (deleteCoupon(coupon))
                                    }, [
                                        _hoisted_22,
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "coupons")), 1)
                                    ], 8, _hoisted_21))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: couponFormModalIsOpen.value,
                    title: selectedCoupon.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_coupon_modal_title', 'Edit Coupon: {name}', 'coupons', { name: selectedCoupon.value.name })
                        : (0, vue_2.unref)(i18n_1.trans)('add_coupon_modal', 'Add Coupon', 'coupons'),
                    onClose: _cache[16] || (_cache[16] = ($event) => (couponFormModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'coupons'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_3.AsyncSearchInput), {
                            ref_key: "customerAsyncSearchInput",
                            ref: customerAsyncSearchInput,
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_placeholder', 'Customer', 'coupons'),
                            label: (0, vue_2.unref)(i18n_1.trans)('customer_label', 'Customer', 'coupons'),
                            border: "",
                            onSearchedValueChanged: customerSearchedValueChanged,
                            onSelected: customerSelected,
                            options: (0, vue_2.unref)(customerOptions)
                        }, null, 8, ["placeholder", "label", "options"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_23, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('coupon_original_value_placeholder', 'Coupon Original Value', 'coupons'),
                                label: (0, vue_2.unref)(i18n_1.trans)('coupon_original_value_label', 'Coupon Original Value (only HUF)', 'coupons'),
                                required: "",
                                min: "1",
                                type: "number",
                                modelValue: couponRequest.value.originalValue,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((couponRequest.value.originalValue) = $event)),
                                class: "my-5 grow pr-2",
                                border: ""
                            }, null, 8, ["placeholder", "label", "modelValue"]),
                            (selectedCoupon.value !== null)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.ShopInput), {
                                    key: 0,
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('coupon_remain_value_placeholder', 'Coupon Remain Value', 'coupons'),
                                    label: (0, vue_2.unref)(i18n_1.trans)('coupon_remain_value_label', 'Coupon Remain Value (only HUF)', 'coupons'),
                                    required: "",
                                    min: "0",
                                    type: "number",
                                    modelValue: couponRequest.value.remainValue,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((couponRequest.value.remainValue) = $event)),
                                    class: "my-5 grow",
                                    border: ""
                                }, null, 8, ["placeholder", "label", "modelValue"]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                            (0, vue_2.createVNode)(QuickDateInput_vue_1.default, {
                                modelValue: couponRequest.value.beginDate,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((couponRequest.value.beginDate) = $event)),
                                class: "grow pr-2",
                                label: (0, vue_2.unref)(i18n_1.trans)('begin_date_label', 'Begin Date', 'coupons')
                            }, null, 8, ["modelValue", "label"]),
                            (0, vue_2.createVNode)(QuickDateInput_vue_1.default, {
                                modelValue: couponRequest.value.endDate,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((couponRequest.value.endDate) = $event)),
                                class: "grow",
                                label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'coupons')
                            }, null, 8, ["modelValue", "label"])
                        ]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('coupon_name_placeholder', 'Coupon Name', 'coupons'),
                            label: (0, vue_2.unref)(i18n_1.trans)('coupon_name_label', 'Coupon Name', 'coupons'),
                            required: "",
                            modelValue: couponRequest.value.name,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((couponRequest.value.name) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                            modelValue: couponRequest.value.description,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((couponRequest.value.description) = $event)),
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('coupon_description_placeholder', 'Coupon Description', 'coupons'),
                            label: (0, vue_2.unref)(i18n_1.trans)('coupon_description_label', 'Coupon Description', 'coupons'),
                            rows: 5,
                            class: "my-5",
                            border: ""
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-success",
                                onClick: _cache[15] || (_cache[15] = ($event) => (selectedCoupon.value === null
                                    ? createCoupon()
                                    : updateCoupon()))
                            }, [
                                _hoisted_26,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "coupons")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: uploadCouponsModalIsOpen.value,
                    title: (0, vue_2.unref)(i18n_1.trans)('upload_coupons_modal', 'Upload Coupons', 'coupons'),
                    onClose: _cache[19] || (_cache[19] = ($event) => (uploadCouponsModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'coupons'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload_manual", "First download the sample csv and fill it, then upload back! Dont delete the header of the CSV!", "coupons")) + " ", 1),
                            (0, vue_2.createElementVNode)("a", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("coupons_sample_csv", "Download Coupons Sample CSV", "coupons")), 1)
                        ]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_3.FileInput), {
                            class: "mt-3",
                            accept: "text/csv",
                            placeholder: "coupons.csv",
                            modelValue: uploadedCsv.value,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((uploadedCsv).value = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('upload_csv', 'Upload CSV', 'coupons')
                        }, null, 8, ["modelValue", "label"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_28, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-success",
                                onClick: _cache[18] || (_cache[18] = ($event) => (uploadCsv()))
                            }, [
                                _hoisted_29,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "coupons")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
